import { handleActions } from 'redux-actions'
// import { setOnSuccess } from 'lp-redux-api'
// import { selectorForSlice } from 'lp-redux-utils'
// import { createSelector } from 'reselect'
// import * as apiActions from 'api-actions'

const reducerKey = 'dashboard'
// const slice = 'root.schoolPortal.dashboard'

const initialState = {}

const reducer = handleActions({}, initialState)

// const select = selectorForSlice(slice)

const selectors = {}

export { reducer, selectors, reducerKey }
